import React from "react";
import "./TimeSlot.css";
import { useReservation } from "../context/ReservationContext";

function TimeSlot() {
  const {
    selectedDate,
    selectedTime,
    groupedSlots,
    handleDateSelect,
    handleTimeSelect,
  } = useReservation();

  const handleTimeClick = (slotIndex) => {
    if (!groupedSlots[selectedDate]) return;
    const timeSlot = groupedSlots[selectedDate].find(
      (slot) => slot.index === slotIndex,
    );
    if (timeSlot && !timeSlot.isReserved) {
      handleTimeSelect(slotIndex);
    }
  };

  return (
    <div className="time-slot-container">
      <div className="time-slot-grid">
        <div className="date-headers">
          {Object.keys(groupedSlots).map((date) => (
            <button
              key={date}
              className={`date-header ${selectedDate === date ? "selected" : ""}`}
              onClick={() => handleDateSelect(date)}
            >
              {new Date(date).toLocaleDateString("en-EN", {
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </button>
          ))}
        </div>

        {selectedDate && groupedSlots[selectedDate] && (
          <div className="time-slots">
            {groupedSlots[selectedDate].map((time) => (
              <button
                key={time.index}
                className={`time-button ${time.isReserved ? "reserved" : ""} ${
                  selectedTime === time.index ? "selected" : ""
                }`}
                onClick={() => handleTimeClick(time.index)}
                disabled={time.isReserved}
              >
                {time.time}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default TimeSlot;
